export const navBarViews = [
  {
    activeRouteMatcher: new RegExp(
      '/executive|insights|sales-insights|shopper-intelligence|demographics|benchmarks/',
      'g',
    ),
    icon: 'mdi-home',
    links: [
      { name: 'Insights', route: '/dashboard/insights' },
      { name: 'Sales Insights', route: '/dashboard/sales-insights' },
      { name: 'Shopper Intelligence', route: '/dashboard/shopper-intelligence' },
      { name: 'Category Benchmarks', route: '/dashboard/benchmarks/category' },
      { name: 'Brand Benchmarks', route: '/dashboard/benchmarks/brand' },
    ],
    requiresCommerceEditor: false,
    selfServe: true,
    title: 'Dashboard',
  },
  {
    activeRouteMatcher: new RegExp(
      'explorer|saved-reports|saved-reports-base',
      'g',
    ),
    icon: 'mdi-file',
    links: [
      { name: 'Explorer', route: '/dashboard/explorer' },
      { name: 'Saved Reports', route: '/dashboard/saved-reports' },
    ],
    requiresCommerceEditor: false,
    selfServe: true,
    title: 'Reporting',
  },
  {
    activeRouteMatcher: 'commerce',
    icon: 'mdi-cart',
    links: [
      { name: 'Commerce', route: '/commerce' },
    ],
    requiresCommerceEditor: true,
    selfServe: true,
    title: 'Commerce',
  },
  {
    activeRouteMatcher: 'media-manager',
    icon: 'mdi-link',
    links: [
      { name: 'Media Manager', route: '/media-manager' },
    ],
    requiresMediaManager: true,
    selfServe: true,
    title: 'Media Manager',
  },
  {
    activeRouteMatcher: new RegExp(
      'brands|carts|data-management|users|edit-brand|create-brand|edit-cart|create-cart',
      'g',
    ),
    icon: 'mdi-account-multiple',
    links: [
      { name: 'Brands', route: '/brands' },
      { name: 'Carts', route: '/carts' },
      { name: 'Data Management', route: '/data-management' },
      { name: 'Users', route: '/users' },
    ],
    requiresCommerceEditor: true,
    selfServe: true,
    title: 'Internal',
  },
];

export const publicPaths = [
  '/access-denied',
  '/attach-studio/preview',
  '/ip-test',
  '/login',
  '/login-redirect',
  '/test-creative',
];
